import api from "@helpers/api";
import { t } from "@i18n";

/**
 * Delete a material
 * @param {string|number} materialId - Material ID to delete
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export async function deleteMaterial(materialId) {
    try {
        const { data } = await api.delete(`material/${materialId}`);

        return { success: true, data };
    } catch (error) {
        console.error('Error deleting material:', error);

        return {
            success: false,
            error: t('contentModals:manageMaterial.errors.deleteFailed')
        };
    }
}
